import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserNamePipeModule } from '@wilson/account';
import { UserQualificationV2 } from '@wilson/interfaces';
import { LocalizedDateTimeFormatPipe } from '@wilson/localization';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'wilson-qualification-last-edit-renderer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslatePipe,
    UserNamePipeModule,
    LocalizedDateTimeFormatPipe,
    NzTooltipModule,
    DateFnsModule,
  ],
  template: `<div>
    @if (qualiLastEdited && qualiLastEdited.updatedAt) {
      <div class="text-dark">
        {{ qualiLastEdited.updatedById | userName | async }}
      </div>
      @let updatedAt =
        qualiLastEdited.updatedAt | dfnsParseIso | localizedDateTimeFormat;
      <div
        class="list-header lh-m"
        nz-tooltip
        [nzTooltipTitle]="updatedAt"
        nzTooltipColor="#fff"
      >
        {{ updatedAt }}
      </div>
    } @else if (qualiLastEdited && qualiLastEdited.createdAt) {
      <div class="text-dark">
        {{ qualiLastEdited.createdById | userName | async }}
      </div>
      @let createdAt =
        qualiLastEdited.createdAt | dfnsParseIso | localizedDateTimeFormat;
      <div
        class="list-header lh-m"
        nz-tooltip
        [nzTooltipTitle]="createdAt"
        nzTooltipColor="#fff"
      >
        {{ createdAt }}
      </div>
    } @else {
      <div class="text-dark">{{ 'general.n/a' | translate }}</div>
      <div class="list-header lh-m">{{ 'general.n/a' | translate }}</div>
    }
  </div>`,
})
export class QualificationLastEditRendererComponent
  implements AgRendererComponent
{
  public qualiLastEdited:
    | Pick<
        UserQualificationV2,
        'createdAt' | 'createdById' | 'updatedAt' | 'updatedById'
      >
    | undefined;

  agInit(params: ICellRendererParams): void {
    this.setValuesToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValuesToDisplay(params);
    return true;
  }

  setValuesToDisplay(params: ICellRendererParams): void {
    if (
      params.data &&
      'createdAt' in params.data &&
      'createdById' in params.data &&
      'updatedAt' in params.data &&
      'updatedById' in params.data
    ) {
      this.qualiLastEdited = {
        createdAt: params.data.createdAt,
        createdById: params.data.createdById,
        updatedAt: params.data.updatedAt,
        updatedById: params.data.updatedById,
      };
    } else {
      this.qualiLastEdited = undefined;
    }
  }
}
